module.exports = __webpack_public_path__ + "img/close_small.93a44473.svg";